import { Instance, types as t } from 'mobx-state-tree';

export const CaptionData = t.model('CaptionData', {
  start: t.maybeNull(t.number), // value as milliseconds
  end: t.maybeNull(t.number), // value as milliseconds
  text: t.maybeNull<any>(t.string),
});

export const ScriptCaption = t.model('ScriptCaption', {
  type: t.string,
  data: CaptionData,
});

export interface ScriptCaptionInstance extends Instance<typeof ScriptCaption> {}
